// extracted by mini-css-extract-plugin
export default {"homeContent__top":"c-i_cs","homeContent__bottom":"c-i_ct","homeContent__cardHolder":"c-i_cu","homeContent__seoTextHolder":"c-i_cv"};